import React, { useState } from 'react';

const getRiskClass = (risk) => {
  if (!risk) return 'badge-default';
  const r = risk.toUpperCase();
  if (r === 'BASSO' || r === 'LOW') return 'badge-risk-low';
  if (r === 'MEDIO' || r === 'MEDIUM') return 'badge-risk-medium';
  if (r === 'ALTO' || r === 'HIGH') return 'badge-risk-high';
  return 'badge-default';
};

const getCardRiskClass = (risk) => {
  if (!risk) return '';
  const r = risk.toUpperCase();
  if (r === 'BASSO' || r === 'LOW') return 'risk-low';
  if (r === 'MEDIO' || r === 'MEDIUM') return 'risk-medium';
  if (r === 'ALTO' || r === 'HIGH') return 'risk-high';
  return '';
};

const ContractCard = ({ contract }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`contract-card ${getCardRiskClass(contract.risk)}`}>
      <div className="contract-header">
        <div>
          <div className="contract-customer">{contract.customer}</div>
          <div className="contract-mandante">{contract.mandante}{contract.categoria ? ` · ${contract.categoria}` : ''}</div>
        </div>
        <span className={`badge ${getRiskClass(contract.risk)}`}>
          {contract.risk || 'N/A'}
        </span>
      </div>
      <div className="contract-meta">
        <span className="contract-meta-item">📄 {contract.contractCode}</span>
        <span className="contract-meta-item">📦 {contract.productName}</span>
        <span className="contract-meta-item">📅 {contract.date}</span>
      </div>
      <button className="contract-details-toggle" onClick={() => setExpanded(!expanded)}>
        {expanded ? 'Nascondi dettagli ▲' : 'Mostra dettagli ▼'}
      </button>
      {expanded && (
        <div className="contract-details-expanded">
          <div className="contract-detail-row">
            <span className="contract-detail-label">Codice agente</span>
            <span className="contract-detail-value">{contract.agentCode}</span>
          </div>
          <div className="contract-detail-row">
            <span className="contract-detail-label">Codice prodotto</span>
            <span className="contract-detail-value">{contract.productCode}</span>
          </div>
          <div className="contract-detail-row">
            <span className="contract-detail-label">Pagamento</span>
            <span className="contract-detail-value">{contract.paymentMethod}</span>
          </div>
          <div className="contract-detail-row">
            <span className="contract-detail-label">Stato</span>
            <span className="contract-detail-value">{contract.status}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractCard;
